module.exports = __webpack_public_path__ + "img/search_mono.460eb77f.svg";